import reset from "styled-reset";
import {
  css,
  createGlobalStyle
} from "styled-components";

import {
  MochaMatteriFontStyle,
  BryantProFontStyle,
  FuturaLTFontStyle,
  NeoHansStyle,
  PieplarStyle,
  CalibriStyle,
  BrandonGrotesqueStyle,
  ClaredonStyle,
  MicrobrewSoftFourStyle,
  HumbleCraftman,
  Poppins
} from "./FontStyles";
import { TableStyles } from "./TablesStyles";
import { ToastStyles } from "./ToastStyles";

export const GlobalStyles = createGlobalStyle`
  ${({ theme }) => {
    const { heading, body } = theme.fonts.family;
    const loadMochaMatteri = heading === "Mocha Mattari" || body === "Mocha Mattari";
    const loadBrayantPro = heading === "Bryant Pro" || body === "Bryant Pro";
    const loadFuturaLTPro = heading === "Futura LT" || body === "Futura LT";
    const loadNeoHans = heading === "Neo Hans" || body === "Neo Hans";
    const loadPieplar = heading === "Pieplar" || body === "Pieplar";
    const loadCalibri = heading === "Calibri" || body === "Calibri";
    const loadBrandonGrotesque = heading === "Brandon Grotesque" || body === "Brandon Grotesque";
    const loadClaredon = heading === "Claredon" || body === "Claredon";
    const loadMicrobrewSoftFour = heading === "Microbrew Soft Four" || body === "Microbrew Soft Four";
    const loadHumbleCraftman = heading === "HumbleCraftman" || body === "HumbleCraftman";
    const loadPoppins = heading === "Poppins" || body === "Poppins";

    return css`
    ${loadCalibri && CalibriStyle};  
    ${loadMochaMatteri && MochaMatteriFontStyle};
      ${loadBrayantPro && BryantProFontStyle};
      ${loadFuturaLTPro && FuturaLTFontStyle};
      ${loadNeoHans && NeoHansStyle};
      ${loadPieplar && PieplarStyle};
      ${loadBrandonGrotesque && BrandonGrotesqueStyle};
      ${loadClaredon && ClaredonStyle};
      ${loadMicrobrewSoftFour && MicrobrewSoftFourStyle};
      ${loadHumbleCraftman && HumbleCraftman};
      ${loadPoppins && Poppins};
    `;
  }}

  * {
    box-sizing: border-box;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar:not(.main-wrapper) {
      width: 0 !important;
      height: 0 !important;
    }
  }



  img {
    display: block;

    &.fluid {
      width: 100%;
    }
  }

  html {
    font-size: 62.5%; /* 10px */
  }

  body {
    font-family: '${({ theme }) => theme.fonts.family.body || "Roboto"}', Helvetica;
    font-weight: 300;
    width: 100%;
    margin: 0;
    background:  ${({ theme }) => theme.colors.ziggurat};
    color: ${({ theme }) => theme.fonts.colors.primary};
    -webkit-overflow-scrolling: touch;

    .storybook-readme-story > div > div {
      margin: 0 auto;
      width: 94%;
    }

    ${reset};
    ${TableStyles}
    ${ToastStyles}
  }

  sub {
    font-size:${({ theme }) => theme.fonts.sizes.sub} !important;
    color: ${({ theme }) => theme.fonts.colors.secondary};
  }
`;
